import { useCart } from "../../../context/CartContext";
import {
  AddToCartRequest,
  CartType,
  ProductType,
} from "../../../Redux/custmoer_cart_service/types";
import { fetchProductById } from "../../../Redux/ecommersProduct/slice";
import { useAppDispatch, useAppSelector } from "../../../Redux/hooks";
import {
  getProductOverallRating,
  getProductReviewPercentage,
  getReviewsByProductId,
} from "../../../Redux/products review/slice";
import { RootState } from "../../../store";
import CategoriesBar from "../../globalcomponents/navbar/categorieslist/CategoriesBar";
import NavbarTwo from "../../globalcomponents/navbar/NavbarTwo";
import BoughtTogether from "../detailpage/boughttogether/BoughtTogether";
import ProductReviews from "../detailpage/detailpagereviews/ProductReviews";
import BrowsingHistory from "../ProductsCards/BrowsingHistory";
import FrequentlyBrought from "../ProductsCards/FrequentlyBrought";
import { useEffect } from "react";

import { useParams } from "react-router-dom";
import RelatedProducts from "../ProductsCards/Relatedprodu";

const SellerDetail = () => {
  const id = useParams().id;
  const dispatch = useAppDispatch();
  const { currentProduct, loading, error } = useAppSelector(
    (state: RootState) => state.eCommerceProducts,
  );
  const { addItemToCart, loading: cartLoading, error: cartError } = useCart();

  const {
    productReviews,
    productRating,
    productReviewPercentage,
    pagination,
    isLoading,
    error: reviewError,
  } = useAppSelector((state: RootState) => state.productsReview);

  useEffect(() => {
    if (id) {
      dispatch(fetchProductById(id as string));
      dispatch(getProductReviewPercentage(id as string));
      dispatch(getProductOverallRating(id as string));
      dispatch(
        getReviewsByProductId({ productId: id as string, page: 1, limit: 5 }),
      );
    }
  }, [dispatch, id]);

  const handleAddToCart = async () => {
    if (!currentProduct) return;

    const addToCartData: AddToCartRequest = {
      productId: currentProduct._id,
      productName: currentProduct.name,
      productImage: currentProduct.mainImage,
      productType: ProductType.PHYSICAL,
      variantId: currentProduct.variations?.[0]?.ssin || "",
      variantName: currentProduct.variations?.[0]?.sku || "",
      quantity: 1,
      unitPrice: currentProduct.variations?.[0]?.pricing?.finalPrice || 0,
      sellerId: currentProduct.creatorId,
      sellerName: currentProduct.vendors?.marketedBy,
      isMLMProduct: false,
      isAdminProduct: currentProduct.createdBy === "ADMIN" ? true : false,
    };

    try {
      const resultAction = await addItemToCart(addToCartData, CartType.ECOMMERCE);

      // Guests get a sign-in toast + redirect from CartContext instead
      if (!resultAction) return;

      const addToCart_fulfilled = (action: any) => action.type.endsWith("/fulfilled");

      if (addToCart_fulfilled(resultAction)) {
        // Automatically open the side cart
        const offcanvasElement = document.getElementById("offcanvasMiniCart");
        if (offcanvasElement) {
          const bootstrap = (window as any).bootstrap;
          if (bootstrap && (window as any).bootstrap.Offcanvas) {
            const bsOffcanvas = new (window as any).bootstrap.Offcanvas(
              offcanvasElement,
            );
            bsOffcanvas.show();
          }
        }
      } else {
        alert(cartError || "Failed to add item to cart");
      }
    } catch (error) {
      console.error("Add to cart error:", error);
    }
  };

  return (
    <>
      <div className=" display-max">
        <NavbarTwo />
        <CategoriesBar />
        <div className=" container">
          <div className=" card w-80 mx-auto shadow-lg p-3 mt-4">
            <div className=" d-flex justify-content-between align-items-center px-3">
              <div className=" w-100">
                <div className=" lh-0 mb-3">
                  <h2 className=" text-black fw-normal">
                    {currentProduct?.vendors?.marketedBy}
                  </h2>
                  <a href="/SellerListing">
                    <b className=" text-black fw-normal text-decoration-line ">
                      Visit the {currentProduct?.vendors?.marketedBy} storefront
                    </b>
                  </a>
                </div>
                <div>
                  <span>
                    {" "}
                    {Array.from(
                      { length: currentProduct?.reviews?.averageRating ?? 0 },
                      (_, index) => (
                        <i
                          key={index}
                          className="bi bi-star-fill text-yellow"
                        ></i>
                      ),
                    )}
                  </span>{" "}
                  &nbsp; | &nbsp;{" "}
                  <b className=" text-black text-sm">
                    {currentProduct?.reviews?.averageRating} reviews{" "}
                  </b>{" "}
                  <b className=" text-black fw-normal text-sm">
                    in the last 12 months (
                    {currentProduct?.reviews?.totalReviews})
                  </b>
                  ratings
                </div>
              </div>
              <div>
                <div className="d-flex align-items-center gap-2">
                  <div className=" w-30">
                    <img src={currentProduct?.mainImage} height="130" alt="" />
                  </div>
                  <div>
                    <b className=" text-black text-md">
                      {currentProduct?.name}
                    </b>
                    <div className=" mt-3 mb-3">
                      <h5 className=" text-black fw-bold">
                        <sup className="fs-6 fw-light me-0">₹</sup>
                        {currentProduct?.variations?.[0]?.pricing?.finalPrice}
                      </h5>
                    </div>
                    <div className=" mt-3">
                      <button
                        className=" btn btn-md btn-yellow w-90 border-radius-lg mx-auto"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#offcanvasMiniCart"
                        aria-controls="offcanvasMiniCart"
                        onClick={handleAddToCart}
                        disabled={cartLoading}
                      >
                        {cartLoading ? "Adding..." : "Add to Cart"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className=" card w-80 mx-auto shadow-lg p-2 mt-4">
            <div className=" d-flex justify-content-between align-items-center px-3">
              <div className=" w-100">
                <div className=" lh-0 mb-5">
                  <h3 className=" text-black fw-bold">Reviews</h3>
                </div>
              </div>
            </div>
            <div className=" mt-3 mb-3">
              <div className=" container w-100 pt-1 pb-6 ">
                <ProductReviews
                  productrating={productRating}
                  productreviewpercentage={productReviewPercentage}
                  productreviews={productReviews}
                />
              </div>
            </div>
          </div>
          <div className=" d-flex justify-content-start align-items-center gap-3 w-80 mt-4 mx-auto">
            <div className=" w-100">
              <a href="/SellerListing">
                <div className=" card shadow-lg p-3">
                  <div className=" d-flex justify-content-between align-items-center">
                    <div>
                      <h5>Return and Refund Policies</h5>
                    </div>
                    <div className=" text-end">
                      <i className="fi fi-rr-angle-right text-black text-md"></i>
                    </div>
                  </div>
                </div>
              </a>
            </div>
            <div className=" w-100">
              <a href="/SellerListing">
                <div className=" card shadow-lg p-3">
                  <div className=" d-flex justify-content-between align-items-center">
                    <div>
                      <h5>Shipping Policies</h5>
                    </div>
                    <div className=" text-end">
                      <i className="fi fi-rr-angle-right text-black text-md"></i>
                    </div>
                  </div>
                </div>
              </a>
            </div>
            <div className=" w-100">
              <a href="/SellerListing">
                <div className=" card shadow-lg p-3">
                  <div className=" d-flex justify-content-between align-items-center">
                    <div>
                      <h5>Other Policies</h5>
                    </div>
                    <div className=" text-end">
                      <i className="fi fi-rr-angle-right text-black text-md"></i>
                    </div>
                  </div>
                </div>
              </a>
            </div>
            <div className=" w-100">
              <a href="/SellerListing">
                <div className=" card shadow-lg p-3">
                  <div className=" d-flex justify-content-between align-items-center">
                    <div>
                      <h5>Help</h5>
                    </div>
                    <div className=" text-end">
                      <i className="fi fi-rr-angle-right text-black text-md"></i>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div className=" mt-4 mb-4 px-3">
            <h5 className=" fw-bolder">
              Customers who bought this item also bought
            </h5>
            <BoughtTogether
              product={currentProduct as any}
              selectedVariation={0}
            />
          </div>
          <div className=" mt-4 mb-4 px-3">
            <h5 className=" fw-bolder">
             Inspired by your interest
            </h5>
            <RelatedProducts
            categoryName={
              currentProduct?.categoryHierarchy.superCategory as string
            }
          />
          </div>
          
        </div>
      </div>
      <div className=" display-mini display-mob">
        <div className=" d-flex justify-content-between align-items-center p-2 shadow-card bg-white position-fixed w-100 z-index-3">
          <div>
            <li className="avatar avatar-sm border-radius-2xl bg-gray-100">
              <a href="/DetailPage">
                <i className="ri-arrow-left-s-line fs-3 me-1 text-black"></i>
              </a>
            </li>
          </div>
          <div className=" d-flex gap-2">
            <li className="avatar avatar-sm border-radius-2xl bg-gray-100">
              <a href=".">
                <i className="bi bi-search fs-6 text-black"></i>
              </a>
            </li>
            <li className="avatar avatar-sm border-radius-2xl bg-gray-100">
              <a href=".">
                <i className="bi bi-bell fs-5 text-black"></i>
              </a>
            </li>
          </div>
        </div>
        <div className=" pt-6 mx-auto px-2">
          <div className=" card mx-auto border-radius-lg shadow p-2">
            <div className=" d-flex justify-content-between align-items-center px-2">
              <div className=" w-100">
                <div className=" lh-0 mb-3">
                  <h2 className=" text-black fw-normal">
                    {currentProduct?.vendors?.marketedBy}
                  </h2>
                  <a href="/SellerListing">
                    <b className=" text-black fw-normal text-decoration-line ">
                      Visit the {currentProduct?.vendors?.marketedBy} storefront
                    </b>
                  </a>
                </div>
                <div>
                  <span>
                    {" "}
                    {Array.from(
                      { length: currentProduct?.reviews?.averageRating ?? 0 },
                      (_, index) => (
                        <i
                          key={index}
                          className="bi bi-star-fill text-yellow"
                        ></i>
                      ),
                    )}
                  </span>{" "}
                  &nbsp; | &nbsp;{" "}
                  <b className=" text-black text-sm">
                    {currentProduct?.reviews?.averageRating} reviews{" "}
                  </b>{" "}
                  <b className=" text-black fw-normal text-sm">
                    in the last 12 months (
                    {currentProduct?.reviews?.totalReviews})
                  </b>
                  ratings
                </div>
              </div>
            </div>
          </div>
          <div className=" mt-3 mb-3">
            <div className=" mt-3 mb-3">
              <div className=" container w-100 pt-1 pb-6 ">
                <ProductReviews
                  productrating={productRating}
                  productreviewpercentage={productReviewPercentage}
                  productreviews={productReviews}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SellerDetail;
